import React from 'react';
import { InstagramIcon, FacebookIcon, SendIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-dark-base border-t border-neon-cyan/20" data-id="element-31">
      <div className="container mx-auto max-w-7xl px-4 py-12" data-id="element-32">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-33">
          {/* Brand Column */}
          <div className="md:col-span-2" data-id="element-34">
            <div className="mb-4" data-id="element-35">
              <h3 className="text-2xl font-black text-gradient-cyan mb-2" data-id="element-36">
                GreenHS
              </h3>
              <p className="text-gray-400 text-sm" data-id="element-37">
                Smarter Betting Starts Here.
              </p>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed" data-id="element-38">
              Join 20,000+ bettors across Africa who trust our proven insights
              and enjoy a 90% success rate daily.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-39">
            <h4 className="text-white font-bold mb-4" data-id="element-40">Quick Links</h4>
            <ul className="space-y-2" data-id="element-41">
              <li data-id="element-42">
                <a href="#hero" className="text-gray-400 hover:text-neon-cyan transition-colors text-sm" data-id="element-43">
                  Home
                </a>
              </li>
              <li data-id="element-44">
                <a href="#predictions" className="text-gray-400 hover:text-neon-cyan transition-colors text-sm" data-id="element-45">
                  Free Predictions
                </a>
              </li>
              <li data-id="element-46">
                <a href="https://greenhsvip.site/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-neon-cyan transition-colors text-sm" data-id="element-47">
                  VIP Access
                </a>
              </li>
              <li data-id="element-48">
                <a href="#updates" className="text-gray-400 hover:text-neon-cyan transition-colors text-sm" data-id="element-49">
                  Latest Updates
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div data-id="element-50">
            <h4 className="text-white font-bold mb-4" data-id="element-51">Support</h4>
            <ul className="space-y-2" data-id="element-52">
              <li data-id="element-53">
                <a href="#faq" className="text-gray-400 hover:text-neon-cyan transition-colors text-sm" data-id="element-54">
                  FAQ
                </a>
              </li>
              <li data-id="element-55">
                <a href="https://t.me/m/P_Y7-ueGMzk0" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-neon-cyan transition-colors text-sm" data-id="element-56">
                  Contact Support
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" className="text-gray-400 hover:text-neon-cyan transition-colors text-sm" data-id="element-58">
                  Terms & Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Neon Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-neon-cyan to-transparent mb-8" data-id="element-59"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-60">
          {/* Copyright */}
          <div className="text-gray-500 text-sm" data-id="element-61">
            © 2025 GreenHS. All Rights Reserved.
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4" data-id="element-62">
            <a href="https://t.me/+X8ENbuhiohkyOTU8" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-dark-card border border-gray-700 hover:border-neon-cyan rounded-full flex items-center justify-center transition-all hover:scale-110 group" aria-label="Telegram" data-id="element-63">
              <SendIcon className="w-5 h-5 text-gray-400 group-hover:text-neon-cyan transition-colors" data-id="element-64" />
            </a>
            <a href="https://instagram.com/greenhighstakers" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-dark-card border border-gray-700 hover:border-neon-purple rounded-full flex items-center justify-center transition-all hover:scale-110 group" aria-label="Instagram" data-id="element-65">
              <InstagramIcon className="w-5 h-5 text-gray-400 group-hover:text-neon-purple transition-colors" data-id="element-66" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-dark-card border border-gray-700 hover:border-neon-cyan rounded-full flex items-center justify-center transition-all hover:scale-110 group" aria-label="Facebook" data-id="element-67">
              <FacebookIcon className="w-5 h-5 text-gray-400 group-hover:text-neon-cyan transition-colors" data-id="element-68" />
            </a>
          </div>

          {/* Telegram Handle */}
          <div className="text-gray-500 text-sm" data-id="element-69">
            <a href="https://t.me/+X8ENbuhiohkyOTU8" target="_blank" rel="noopener noreferrer" className="hover:text-neon-cyan transition-colors" data-id="element-70">
              @GreenHSChannel
            </a>
          </div>
        </div>
      </div>
    </footer>;
}